import Container from 'components/container';
import { Body, Heading } from 'components/text';
import { FC } from 'react';

const About: FC<{}> = () => {
  return (
    <Container className="myler-about-section" id="about" as="section">
      <Heading as="h4">About MyLER</Heading>
      <div className="myler-about-section__subtitle">
        <Heading as="h2">
          Turning your passion for travel into profit, our tech-savvy platform
          lets you earn income while booking travel from anywhere, anytime,
          whilst always reassuringly supported by Little Emperors industry
          leading professionalism
        </Heading>
      </div>
      <div className="myler-about-section__body">
        <Body color="grey-dark" className="myler-about-section__body__text">
          Allowing you to earn income and create unforgettable experiences by
          booking exceptional trips for your clients
        </Body>
      </div>
    </Container>
  );
};

export default About;
